import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex flex-column h-100" }
const _hoisted_2 = { class: "d-flex p-2 scrollbar" }
const _hoisted_3 = { class: "flex-fill" }
const _hoisted_4 = { class: "flex-fill position-relative" }
const _hoisted_5 = {
  class: "d-flex align-items-center",
  style: {"max-width":"100%","min-width":"0"}
}
const _hoisted_6 = { class: "pr-2" }
const _hoisted_7 = {
  class: "flex-fill",
  style: {"min-width":"0"}
}
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = {
  class: "flex-fill font-weight-600",
  style: {"min-width":"0"}
}
const _hoisted_10 = { class: "pl-2 text-muted" }
const _hoisted_11 = { class: "mt-1" }
const _hoisted_12 = { class: "text-truncate" }
const _hoisted_13 = {
  key: 0,
  class: "text-center mt-2"
}
const _hoisted_14 = {
  key: 1,
  class: "text-center mt-4 mt-2"
}

import InfiniteScrollContainer from "~/core-ui/vue/InfiniteScrollContainer.vue";
import {computed, getCurrentInstance, onMounted} from "vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import ObjectHelper from "~/ts/library/ObjectHelper";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import CoreUiChatHistoryMessageTitle from "~/core-ui/vue/chat/CoreUiChatHistoryMessageTitle.vue";
import {getOperatorByMessage} from "~/operatorApplication/ts/service/operators/getOperatorByMessage";
import CoreUiChatHistoryMessageAvatar from "~/core-ui/vue/chat/CoreUiChatHistoryMessageAvatar.vue";
import StringHelper from "~/ts/library/StringHelper";
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";
import getTimeStringByTimestamp from "~/operatorApplication/ts/service/buddyList/getTimeStringByTimestamp";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import {
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {
    SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME,
    ScrollToClientMessageByIdPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";
import {InputInstance} from "element-plus";

import OperatorApplicationClientOpenApiModel = OperatorApplicationApi.OperatorApplicationClientOpenApiModel;

import {defineComponent, ref} from 'vue';
import {__} from "~/ts/library/Translate";

const __default__ = defineComponent({
    name: "MessageSearchTab"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    userdata: {},
    site: {}
  },
  setup(__props: any) {

let props = __props;

let isMounted = ref(false);
let instance = getCurrentInstance().proxy;
let scrollContainer = ref<HTMLDivElement>();
let selectedMessage = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel>();

let searchInput = ref<InputInstance>();

onMounted(() => {
    isMounted.value = true;
    searchInput.value.focus();
});


let query = ref<string>();
let queryForRequest = ref<string>();


let refreshKey = ref<number>();

let scrollContainerKey = computed(() => {
    return (queryForRequest.value ?? "") + refreshKey.value;
});

let virtualOperatorsDictionary = computed(() => {
    return props.site ? ObjectHelper.dictionaryFromArray(props.site.virtualOperators, "id") : undefined;
});

function internalGetOperatorByMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    return getOperatorByMessage(message, OperatorAccountStore.operatorsDictionary.value, virtualOperatorsDictionary.value);
}

let messages = ref<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]>();
messages.value = [];

function search() {
    scrollContainer.value.scrollTop = 0;
    messages.value = [];
    refreshKey.value = Date.now();
    queryForRequest.value = query?.value.trim();
}

let loading = ref(false);

async function loadMethod(): Promise<OperatorApplicationApi.OperatorApplicationMessageOpenApiModel[]> {
    if (queryForRequest.value) {
        loading.value = true;
        let p: OperatorApplicationApi.OperatorMessageSearchMessagesOpenApiModel = {
            username: props.userdata.username,
            count: 30,
            firstMessageId: messages.value[messages.value.length - 1]?.id,
            searchQuery: queryForRequest.value
        };
        let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorMessageSearchMessagesResultOpenApiModel>({
            url: "/message/searchMessages",
            p,
            silent: true,
            silentError: true
        })).send();
        loading.value = false;
        if (!result.showMessageOnError()) {
            return result.data.messages;
        } else {
            return [];
        }
    } else {
        return [];
    }
}

function goToMessage(message: OperatorApplicationApi.OperatorApplicationMessageOpenApiModel) {
    let p: ScrollToClientMessageByIdPayloadInterface = {
        messageId: message.id,
        username: props.userdata.username
    };
    OperatorApplicationEventManager.emit(SCROLL_TO_CLIENT_MESSAGE_EVENT_NAME, p);
    selectedMessage.value = message;
}



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createVNode(_component_el_input, {
          placeholder: _unref(__)('Поиск по сообщениям'),
          modelValue: _unref(query),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(query) ? (query).value = $event : query = $event)),
          class: "search-input",
          ref_key: "searchInput",
          ref: searchInput
        }, null, 8, ["placeholder", "modelValue"]), [
          [
            _directive_on_native,
            search,
            "keydown",
            { enter: true }
          ]
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"border-top-left-radius":"0","border-bottom-left-radius":"0"},
          onClick: search
        }, {
          default: _withCtx(() => [
            _createVNode(FontAwesomeIcon, { icon: "search" })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "absolute-full-size scrollbar pl-2 pb-2",
        ref_key: "scrollContainer",
        ref: scrollContainer
      }, [
        (_unref(isMounted))
          ? (_openBlock(), _createBlock(InfiniteScrollContainer, {
              "load-method": loadMethod,
              key: _unref(scrollContainerKey),
              "scroll-container": _unref(scrollContainer),
              items: _unref(messages),
              "scroll-direction": "bottom"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (message) => {
                  return _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                    key: message.id,
                    class: _normalizeClass({
                            'mb-2 hoverable': true,
                            selected: message  === _unref(selectedMessage)
                        })
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ElCardSection, { class: "p-2 hoverable" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(CoreUiChatHistoryMessageAvatar, {
                                message: message,
                                client: __props.userdata,
                                "avatar-size": "32px",
                                operator: internalGetOperatorByMessage(message),
                                "show-operator-status": false,
                                you: _unref(OperatorAccountStore).operator.value
                              }, null, 8, ["message", "client", "operator", "you"])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(CoreUiChatHistoryMessageTitle, {
                                    class: "text-truncate",
                                    style: {"min-width":"0"},
                                    message: message,
                                    "operators-dictionary": _unref(OperatorAccountStore).operatorsDictionary.value,
                                    operator: internalGetOperatorByMessage(message),
                                    client: _unref(props).userdata,
                                    "show-receiver": false
                                  }, null, 8, ["message", "operators-dictionary", "operator", "client"])
                                ]),
                                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(getTimeStringByTimestamp)(message.dateTime)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  (typeof message.text == 'string')
                                    ? (_openBlock(), _createBlock(CoreUiHtmlify, {
                                        key: 0,
                                        emoji: "",
                                        value: _unref(StringHelper).htmlToText(_unref(StringHelper).bbcodeToHtml(message.text))
                                      }, null, 8, ["value"]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["class"])), [
                    [_directive_on_native, () => goToMessage(message), "click"]
                  ])
                }), 128)),
                (_unref(loading))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(MyLoader)
                    ]))
                  : (!_unref(messages).length && _unref(queryForRequest)?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[1] || (_cache[1] = [
                        _createElementVNode("h4", null, "Сообщения не найдены", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createElementVNode("div", null, " ", -1))
              ]),
              _: 1
            }, 8, ["scroll-container", "items"]))
          : _createCommentVNode("", true)
      ], 512)
    ])
  ]))
}
}

})